import script from "./EvseDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./EvseDetails.vue?vue&type=script&lang=ts&setup=true"

import "./EvseDetails.vue?vue&type=style&index=0&id=057b1e44&lang=scss"

const __exports__ = script;

export default __exports__